<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="full-height border-box flex-column">
    <div class="w-full drag-bar" cdkDragHandle>
        <fa-icon icon="arrows-alt"></fa-icon>
        <h1 matDialogTitle class="m-0"> {{headline}} </h1>
        <fa-icon class="close-button" icon="times" size="2x" [mat-dialog-close]=""></fa-icon>
    </div>
</div>
<div matDialogContent>
    <form (ngSubmit)="close()" class="flex flex-col">
        <mat-form-field>
            <mat-label>Name</mat-label>
            <input matInput [formControl]="form.controls.key" />
            <mat-error *ngIf="getErrorMessage(form.controls.key) as error">
                {{ error }}
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Beschreibung</mat-label>
            <input matInput [formControl]="form.controls.description" />
            <mat-error *ngIf="getErrorMessage(form.controls.description) as error">
                {{ error }}
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Wert</mat-label>
            <input matInput [formControl]="form.controls.formula" />
            <mat-error *ngIf="getErrorMessage(form.controls.formula) as error">
                {{ error }}
            </mat-error>
            <mat-hint>Es können Formeln genutzt werden</mat-hint>
        </mat-form-field>
        <app-calculation-input-result [formula]="form.controls.formula.value" [maxDecimalPlaces]="maxDecimalPlaces" [mathScope]="scope"></app-calculation-input-result>
    </form>
</div>
<mat-dialog-actions class="flex gap-4 justify-between">
    <button app-button Color="cancel" Inverted [mat-dialog-close]="">abbrechen</button>
    <button app-round-button Color="red" *ngIf="canDelete" [mat-dialog-close]="{ deleted: true }"><fa-icon icon="trash"></fa-icon></button>
    <button app-button Color="green" [Disabled]="form.invalid" (click)="close()">übernehmen</button>
</mat-dialog-actions>
